module.exports = __webpack_public_path__ + "img/corner.5f0d217.png";